import { useRange } from "@website/ui/range/range.hook";
import styles from "@website/ui/range/range.module.scss";
import { RangePropertiesType } from "@website/ui/range/range.types";
import { deepCompare } from "@website/utils/deep-compare";
import { FC, memo } from "react";

const Range: FC<RangePropertiesType> = (properties) => {
  const { startText, endText, color } = properties;
  const {
    stepItems,
    minInputProperties,
    maxInputProperties,
    rangeProperties,
    isSingle
  } = useRange(properties);

  return (
    <div>
      {startText || endText ? (
        <div className={styles["text"]}>
          <span>{startText}</span>
          <span>{endText}</span>
        </div>
      ) : (
        ""
      )}
      <div
        className={`${styles["range-wrapper"]} ${styles[color || "primary"]}`}
      >
        {!isSingle && (
          <input
            className={`${styles["input"]} ${styles["first"]}`}
            aria-label="Minimum value"
            {...minInputProperties}
          />
        )}
        <input
          className={`${styles["input"]} ${styles["second"]}`}
          aria-label="Maximum value"
          {...maxInputProperties}
        />
        {stepItems.length > 0 && (
          <div className={styles["steps-wrapper"]}>
            {stepItems.map(({ out, id }) => (
              <div
                className={`${styles["step"]} ${out ? styles["out"] : ""}`}
                key={id}
              />
            ))}
          </div>
        )}
        <div className={styles["track"]} />
        <div className={styles["range"]} {...rangeProperties} />
      </div>
    </div>
  );
};

const RangeMemoized = memo(Range, deepCompare);
export { RangeMemoized as Range };
